import { createRootRoute, Outlet } from '@tanstack/react-router'
import { RouteError } from '@/shared/ui/route-state/RouteError'
import { RouteNotFound } from '@/shared/ui/route-state/RouteNotFound'
import { RoutePending } from '@/shared/ui/route-state/RoutePending'

export const Route = createRootRoute({
  component: Outlet,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
})
